import React from 'react';
import { useTranslation } from 'react-i18next';
import { sendTrackingInfo } from '@panel/commons';
import SimpleTag from '@panel/commons/lib/SimpleTag';
import { ContentLayout, SelectedPipe, Img, Label } from './styles';

const TabSelector = ({
  data,
  isSelected,
  setSelectTab,
  icon,
  isAdmin,
  setQueryTab,
  withoutCursorPointer,
  isPortalWithNewReputation
}) => {
  const { t } = useTranslation();
  const toTop = () => window.scrollTo(0, 0);
  const siteId = process.env.REACT_APP_BUILD_SITE;
  const isBrasilSite = ['WIBR', 'IWBR', 'CMBR'].includes(siteId);

  return (
    <ContentLayout
      isSelected={isSelected}
      withoutCursorPointer={withoutCursorPointer}
      onClick={() => {
        if (isAdmin && !isSelected) {
          setSelectTab(data);
          setQueryTab(data);
          sendTrackingInfo('Panel', 'Estadisticas', `Ir a ${t(`panel.estadisticas.leftBar.title.${data}`)}`);
          toTop();
        }
      }}
    >
      {isSelected && <SelectedPipe data-panel={`panel-estadisticas-tabSelected-${data}`} />}
      <Img src={icon} data-panel={`panel-estadisticas-tabIcon-${data}`} />
      <Label data-panel={`panel-estadisticas-tabLabel-${data}`}>{t(`panel.estadisticas.leftBar.title.${data}`)}</Label>
      {data === 'score' && isBrasilSite && isPortalWithNewReputation && (
        <SimpleTag text={t('panel.reputacion.badge')} />
      )}
    </ContentLayout>
  );
};

export default TabSelector;
